__turbopack_context__.v({
  "avatar": "SPeXAq_avatar",
  "container": "SPeXAq_container",
  "copy": "SPeXAq_copy",
  "header": "SPeXAq_header",
  "orgIcon": "SPeXAq_orgIcon",
  "services": "SPeXAq_services",
});
